<template>
    <span/>
</template>

<script>
const { mapState } = require("vuex");

export default {
    name: "milkglass-layer",
    props: ["milkglassHook"],

    computed: {
        ...mapState("transcript", ["eventBus", "opacity"])
    },

    data() {
        return {
            milkglass: undefined
        }
    },

    mounted() {
        this.eventBus.$on('overlay-opacity-change', () => {
            if (this.milkglassHook) {
                setOpacity(this.milkglassHook(), this.opacity)
            }
        })
        this.eventBus.$on('milkglass-create', () => {
            if(this.milkglassHook) {
                initMilkglass(this.milkglassHook())
                setOpacity(this.milkglassHook(), this.opacity)
            }
        })
    },
}

function initMilkglass(node) {
    node.setAttribute("class", "milkglass");
    node.setAttribute("width", "10000");
    node.setAttribute("height", "10000");
}

function setOpacity(milkglass, opacity) {
    if (!milkglass) {
        return;
    }
    milkglass.style.fillOpacity = opacity / 100;
}
</script>
